import { useEffect, useState } from 'react';

const useIsScrollVisible = ({ root, onToggleScrollVisible = () => {} }) => {
  const [isScrollVisible, setIsScrollVisible] = useState(false);

  const handleResize = (entries) => {
    const [element = {}] = entries;
    const { target = {} } = element;

    const isVisible = target.scrollHeight > target.clientHeight;

    if (isVisible === isScrollVisible) return;

    setIsScrollVisible(isVisible);
    onToggleScrollVisible(isVisible);
  };

  useEffect(() => {
    const resizeObserver = new ResizeObserver(handleResize);

    if (root) {
      resizeObserver.observe(root);
    }

    return () => resizeObserver.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [root]);

  return isScrollVisible;
};

export default useIsScrollVisible;
